export const environment = {
  production: true,
  oauth_client_id: '6W8y1Xk1qyU5OhlfmfPEaXqIiMruh4L4UW4bJ83Z',
  oauth_endpoint: 'https://wegwijzerdenhaag.nl',
  graphql_endpoint: 'https://wegwijzerdenhaag.nl/nieuwkomer/api/graphql',
  wegwijzer_url: 'https://wegwijzerdenhaag.nl/',
  api_endpoint: 'https://wegwijzerdenhaag.nl/nieuwkomer/api',
};
